<template>
  <ax-dialog 
    ref="dialog"
    title="Create Filter" 
    icon="mdi-plus" 
    tooltip="Create Filter" 
    size="small" 
    @submitted="onSubmit" 
    :disabled="disabled" persistent
  >
    <template slot="content">
      <v-card-text>
        <v-autocomplete :items="filterFiles" v-model="filter.file" label="File" clearable />
        <v-autocomplete :items="filterColumns" v-model="filter.column" label="Column" clearable />
        <v-autocomplete :items="filterOperators" v-model="filter.operator" label="Operator" clearable />
        <v-autocomplete v-if="!isEmpty(filterValues)" :items="filterValues" v-model="filter.values" label="Value(s)" multiple clearable />
        <v-text-field v-else label="Value(s)" v-model="filter.values" />
      </v-card-text>
    </template>
  </ax-dialog>
</template>
<script>
import AxDialog from "@/components/dialog"
import Files from "@/api/files"
export default {
  name: "DataFilter",
  props: {
    dataset: { type: Object, required: true },
    columns: { type: Object, required: true },
    disabled: { type: Boolean, default: true }
  },
  components: {
    AxDialog,
  },
  data() {
    return {
      filter: {
        file: null,
        column: null,
        operator: null,
        values: []
      },
      operators: ["in", "equals", "contains", "is less than", "is greater than"],
      uniques: []
    }
  },
  computed: {
    isValidFilter() {
      return !!this.filter.file && !!this.filter.column && !!this.filter.operator && this.filter.value.length > 0
    },
    filterFiles() {
      return [
        { text: 'Completion', value: 'completion' },
        { text: 'Production', value: 'production' },
      ]
    },
    filterColumns() {
      return this.columns[this.filter.file]
    },
    filterOperators() {
      return ["in", "equals", "contains", "is less than", "is greater than"]
    },
    filterValues() {
      if (typeof this.uniques == "string") return []
      return this.uniques
    },
  },
  watch: {
    "filter.column": function(val) {
      if (val) {
        Files.uniques(this.dataset[this.filter.file], val).then(response => (this.uniques = response.data))  
      }
    }
  },
  methods: {
    onSubmit() {
      this.$refs.dialog.show = false
      this.$emit('submitted', this.filter)
      this.filter = {
        file: null,
        column: null,
        operator: null,
        value: []
      }
      this.uniques = []
    }
  }
}
</script>